import { Badge, Button, DeprecatedIcon } from '@vinted/web-ui';
import useTranslate from 'hooks/useTranslate';
import { INBOX_URL } from 'constants/routes/inbox';
import useBrazeInboxMessageCards from 'libs/common/braze/hooks/useBrazeInboxMessageCards';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MAX_BADGE_COUNT = 99;

const HeaderConversations = _ref => {
  var _inboxMessageCards$fi;

  let {
    unreadConversationCount = 0
  } = _ref;
  const translate = useTranslate('header.a11y.conversations');
  const {
    inboxMessageCards
  } = useBrazeInboxMessageCards();
  const brazeConversationCount = (_inboxMessageCards$fi = inboxMessageCards === null || inboxMessageCards === void 0 ? void 0 : inboxMessageCards.filter(card => !card.viewed).length) !== null && _inboxMessageCards$fi !== void 0 ? _inboxMessageCards$fi : 0;
  const mergedConversationCount = unreadConversationCount + brazeConversationCount;
  const badgeConversationCount = inboxMessageCards ? Math.min(mergedConversationCount, MAX_BADGE_COUNT) : 0;
  const badgeSuffix = mergedConversationCount > MAX_BADGE_COUNT ? '+' : '';
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, {
      testId: "header-notification-button",
      styling: Button.Styling.Flat,
      deprecatedIcon: /*#__PURE__*/_jsx(DeprecatedIcon, {
        name: "envelope",
        size: DeprecatedIcon.Size.Regular,
        color: DeprecatedIcon.Color.GreyscaleLevel4,
        aria: {
          'aria-label': mergedConversationCount ? translate('new_conversations', {
            count: mergedConversationCount
          }) : translate('conversations')
        }
      }),
      url: INBOX_URL
    }), !!badgeConversationCount && /*#__PURE__*/_jsx("div", {
      className: "user-actions__notification",
      "data-testid": "conversations-badge",
      children: /*#__PURE__*/_jsx(Badge, {
        content: /*#__PURE__*/_jsx("span", {
          "aria-hidden": "true",
          children: "".concat(badgeConversationCount).concat(badgeSuffix)
        }),
        theme: "warning"
      })
    })]
  });
};

export default HeaderConversations;